<body> 
    <h1>ICT Graphs</h1> 
 <div id="chartContainer1" style="width: 45%; height: 300px;display: inline-block; padding: 10px">
    <canvas baseChart 
        [datasets]="barChartData" 
        [labels]="barChartLabels" 
        [options]="barChartOptions"
       
        [legend]="barChartLegend" 
        [chartType]="barChartType">
       
    </canvas>
    <h4> <button type="button" class="btn btn-secondary"><a routerLink="bar" style="color:black">bar chart</a></button></h4>
</div>

<div id="chartContainer1" style="width: 45%; height: 300px;display: inline-block; padding:10px">
 <canvas baseChart 
     [datasets]="pieChartData" 
     [labels]="pieChartLabels" 
     [options]="pieChartOptions"
     
     [legend]="pieChartLegend" 
     [chartType]="pieChartType">
    
 </canvas>
 <h4> <h4> <button type="button" class="btn btn-secondary"><a routerLink="pie" style="color:black">pie chart</a></button></h4></h4>

</div>
<div id="chartContainer1" style="width: 45%; height: 300px;display: inline-block; padding: 10px">
 <canvas baseChart 
     [datasets]="lineChartData" 
     [labels]="lineChartLabels" 
     [options]="lineChartOptions"
     
     [legend]="lineChartLegend" 
     [chartType]="lineChartType">
    
 </canvas>
 <h4>line graph</h4>
</div>
</body>

